import { Component, effect } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';

import {
    SimulationExistingNetworkService,
    ParameterError,
} from '../simulation-existing-network.service';
import {
    AlertModule,
    AlertService,
    ButtonModule,
    ButtonTypes,
    ButtonColors,
    LayerService,
    LayerSize,
    PopupModule,
} from '@ed---interne/ng-uui-components';
import { SharedModule } from '../../../../shared/shared.module';

import { SimulateExistingNetworkComponent } from '../modals/simulate-existing-network/simulate-existing-network.component';

@Component({
    selector: 'app-simulation-existing-network',
    templateUrl: './simulation-existing-network.component.html',
    styleUrl: './simulation-existing-network.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        AlertModule,
        ButtonModule,
        PopupModule,
        SimulateExistingNetworkComponent,
    ],
})
export class SimulationExistingNetworkComponent {
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;

    public isUploading = false;

    public gpkgFile: File | null = null;
    public xlsxFile: File | null = null;

    public resetGpkgCounter = 0;
    public resetXlsxCounter = 0;

    public xlsxErrors: ParameterError[] = [];

    constructor(
        private simulationService: SimulationExistingNetworkService,
        private readonly alertService: AlertService,
        private readonly layerService: LayerService,
    ) {
        effect(() => {
            this.resetGpkgCounter = this.simulationService.gpkgResetSignal();
            this.resetXlsxCounter = this.simulationService.xlsxResetSignal();
        });
    }

    get canRunSimulation() {
        return this.simulationService.canRunExistingNetworkSimulation();
    }

    onGpkgFileUpload(file: File | null) {
        this.simulationService.setGpkgFile(file);
    }

    async onXlsxFileUpload(file: File | null) {
        if (!file) {
            this.simulationService.setXlsxFile(null);
            this.simulationService.clearParams();
            return;
        }

        this.simulationService.setXlsxFile(file);
        this.xlsxErrors = await this.simulationService.extractApiFormatFromExcel(file);
    }

    public downloadTemplate(): void {
        this.alertService.valid('Document', `Le fichier excel a bien été téléchargé`);

        const link = document.createElement('a');
        link.href = 'assets/templates/Template paramètres simulation.xlsx';
        link.download = 'Template paramètres simulation.xlsx';
        link.click();
    }

    public openModalRunSimulation(): void {
        this.layerService.show(SimulateExistingNetworkComponent, {
            size: LayerSize.Medium,
        });
    }
}
